import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FiX } from 'react-icons/fi';
import { useGuestCopy } from './guestCopy';
import { trackEvent } from './analytics';
import { useConversionCopy } from './conversionCopy';
import useVisibleImpression from './useVisibleImpression';
import './guest.css';

export default function GuestSavePrompt({ recordId, location = 'completed_transcript', compact = false, onSave }) {
  const copy = useGuestCopy();
  const conversion = useConversionCopy();
  const [dismissed, setDismissed] = useState(() => {
    try { return Number(sessionStorage.getItem('instanttranscriber_save_prompt_dismissed')) > Date.now(); } catch { return false; }
  });
  const redirect = new URLSearchParams();
  if (recordId) redirect.set('record', recordId);
  const lang = new URLSearchParams(window.location.search).get('lang');
  if (lang) redirect.set('lang', lang);
  const from = `/dashboard${redirect.toString() ? `?${redirect}` : ''}`;
  const params = new URLSearchParams({ redirect_path: from, cta_location: location });

  const tracking = { cta_location: location, offer_variant: 'result_context_v4', event_source: compact ? location : 'visible_prompt' };
  const promptRef = useVisibleImpression(() => trackEvent('guest_save_prompt_view', tracking), `${recordId}:${location}`, !dismissed);
  useEffect(() => {
    const hide = () => setDismissed(true);
    window.addEventListener('instanttranscriber:save-prompt-dismissed', hide);
    return () => window.removeEventListener('instanttranscriber:save-prompt-dismissed', hide);
  }, []);

  if (dismissed) return null;
  return <aside ref={promptRef} className={`guest-save-prompt${compact ? ' guest-save-prompt--compact' : ''}`} aria-label={copy.resultTitle}>
    <button type="button" className="guest-save-prompt__dismiss" aria-label={copy.dismissSave} onClick={() => {
      setDismissed(true);
      try { sessionStorage.setItem('instanttranscriber_save_prompt_dismissed', String(Date.now() + 86400000)); } catch {}
      window.dispatchEvent(new Event('instanttranscriber:save-prompt-dismissed'));
      trackEvent('guest_save_prompt_dismiss', tracking);
    }}><FiX aria-hidden="true" /></button>
    <strong>{conversion.saveTitle}</strong>
    <div className="guest-save-prompt__actions">
      {onSave ? <button type="button" className="guest-save-prompt__save" onClick={() => onSave({ recordId, location, redirectPath: from })}>{conversion.saveAction}</button>
        : <Link to={`/signup?${params}`} state={{ from }}>{conversion.saveAction}</Link>}
    </div>
    <small>{conversion.saveBenefit}</small>
  </aside>;
}
